var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('div',{staticClass:"container"},[_c('InputForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("Recording Fee Calculator")])])
}]

export { render, staticRenderFns }